export function captureExceptionWithDetails(sentry, error, details) {
  sentry.withScope(function(scope) {
    scope.setExtra('data', JSON.stringify(details))
    scope.setExtra('fullError', JSON.stringify(error))
    sentry.captureException(error)
  })
}
